"use client";
import React, { useState, useEffect, useCallback } from "react";
import ReviewItem from "./components/review-item";
import reactionAPI from "@/services/reaction_api";
import reviewAPI from "@/services/review_api";
import commentAPI from "@/services/comment_api";
import InputReview from "@/components/input-review";
import TotalRating from "@/components/total-rating";
import { Avatar, Rate, Pagination, Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import { CiLocationArrow1 } from "react-icons/ci";
import Image from "next/image";
import { useAuth } from "@/hooks";
import { statAPI } from "@/services/stat_api";
import { userActionAPI } from "@/services/user_action_api";
import { ResponseTypes } from "@/types/constants";
import { definitions } from "@/services/metruyenvl";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import { BookData, LOAD_MORE_REVIEW_COMMENT_LIMIT, getListReviews } from "@/redux/reducers/book.reducer";
import { userInfo } from "@/redux/reducers/user.reducer";
import useDeepCompareEffect from "use-deep-compare-effect";

function Review({ slug }: { slug: string }) {
    const dispatch = useDispatch<AppDispatch>();

    const bookData: BookData = useSelector((state: RootState) => state.bookReducer.map[slug as string]);
    const userData = useSelector(userInfo);

    // Thêm, xoá, không cập nhật review
    useEffect(() => {
        console.log("Review -> call useEffect getListReviews: ", bookData);
        const reviewsPaging = bookData.reviews?.paging;
        const reviewsCount = bookData?.detail?.stats?.reviews_count;
        const reviewsTotal = reviewsPaging?.total as number;
        const nextOffset = reviewsPaging?.next_offset as number;
        const reviewsMismatch = reviewsCount !== reviewsTotal;
        const hasMoreReviews = reviewsTotal > nextOffset;

        if (!reviewsPaging || !reviewsTotal || !nextOffset || reviewsTotal <= 0 || reviewsMismatch || hasMoreReviews) {
            const limit = bookData.reviews?.list.length || reviewsTotal - nextOffset || LOAD_MORE_REVIEW_COMMENT_LIMIT;
            console.log("Review -> call useEffect getListReviews call dispatch with offset: ", nextOffset, " with limit: ", limit);
            dispatch(
                getListReviews({
                    userID: userData.info.id as string,
                    bookID: bookData?.detail?.id as string,
                    offset: 0,
                    limit: limit,
                })
            );
        }
        console.log("Review -> call useEffect getListReviews after: ", bookData);
    }, [slug, bookData?.detail?.stats?.reviews_count, bookData?.detail?.stats?.reviews_point]);

    const [reply, setReply] = useState({
        id: "",
        open: false,
    });

    const [comment, setComment] = useState<string>("");

    const replyReview = async (reviewID: string) => {
        setComment("");
        try {
            const res = await commentAPI.create(bookData.detail?.id as string, "review", reviewID, comment);
        } catch (error) {
            console.log(error);
        }
    };

    // TODO: Cần xem lại phần comment của review

    return (
        <Spin spinning={!!bookData?.reviews?.isLoading}>
            <div className="grid grid-cols-1 gap-5 p-1 md:block md:mt-0">
                <div>
                    <InputReview book={bookData.detail as definitions["do.BookDO"]} />
                    {bookData.reviews?.list.length > 0 &&
                        bookData.reviews?.list.map((review: definitions["do.ReviewDO"], index: number) => {
                            return (
                                <div key={review.id}>
                                    <ReviewItem book={bookData?.detail} review={review} />
                                    {reply.id === review.id && reply.open && (
                                        <div className="mt-3 ml-6 flex items-center gap-x-3">
                                            <div>
                                                <Avatar size={72} icon={<Image unoptimized={true} height={72} width={72} src="https://www.looper.com/img/gallery/tanjiros-greatest-power-in-demon-slayer-isnt-what-you-think/l-intro-1620874317.jpg" alt="" />} />
                                            </div>
                                            <div className="relative w-full ">
                                                <TextArea
                                                    className="w-full h-min pr-20 font-semibold"
                                                    style={{ minHeight: "90px" }}
                                                    value={comment}
                                                    onChange={(e) => {
                                                        setComment(e.target.value);
                                                    }}
                                                />
                                                <button
                                                    onClick={() => {
                                                        replyReview(review.id as string);
                                                    }}
                                                    className="absolute z-10 bottom-2 right-3 bg-orange-800 p-2 text-3xl rounded-full"
                                                >
                                                    <CiLocationArrow1 size={10} color="white" />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                </div>
                {(bookData.reviews?.paging?.total || 0) - (bookData.reviews?.paging?.next_offset || 0) > 0 && (
                    <div className="flex items-center justify-center p-4">
                        <button
                            className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                            style={{ background: "rgb(217, 119, 6" }}
                            onClick={() => {
                                dispatch(getListReviews({ userID: userData.info.id as string, bookID: bookData?.detail?.id as string, offset: bookData?.reviews?.paging?.next_offset || 0, limit: LOAD_MORE_REVIEW_COMMENT_LIMIT }));
                            }}
                        >
                            Xem thêm {(bookData.reviews?.paging?.total || 0) - (bookData.reviews?.paging?.next_offset || 0) < LOAD_MORE_REVIEW_COMMENT_LIMIT ? (bookData.reviews?.paging?.total || 0) - (bookData.reviews?.paging?.next_offset || 0) : LOAD_MORE_REVIEW_COMMENT_LIMIT} đánh giá
                        </button>
                    </div>
                )}
                <TotalRating />
            </div>
        </Spin>
    );
}

export default Review;
